import { Link, useLocation } from 'react-router-dom'
import { User, Package, Mail, List, ShoppingCart } from 'lucide-react'
import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { useCart } from '../contexts/CartContext'
import packageJson from '../../package.json'

const MobileBottomNav = () => {
  const location = useLocation()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const { totalCount } = useCart()
  
  const currentYear = new Date().getFullYear()
  const appVersion = packageJson.version || import.meta.env.VITE_REACT_APP_VERSION || process.env.REACT_APP_VERSION || ''
  
  // Vérifier si l'utilisateur est connecté
  useEffect(() => {
    const checkAuthStatus = () => {
      const token = localStorage.getItem('user_token')
      setIsLoggedIn(token !== null)
    }
    
    // Vérifier au montage
    checkAuthStatus()
    
    // Écouter les changements de localStorage
    const handleStorageChange = (e) => {
      if (e.key === 'user_token') {
        checkAuthStatus()
      }
    }
    
    window.addEventListener('storage', handleStorageChange)
    
    // Vérifier périodiquement (pour les changements dans le même onglet)
    const interval = setInterval(checkAuthStatus, 1000)
    
    return () => {
      window.removeEventListener('storage', handleStorageChange)
      clearInterval(interval)
    }
  }, [])

  const navItems = [
    {
      name: 'Compte',
      href: isLoggedIn ? '/account' : '/login',
      icon: User,
      active: location.pathname === '/account' || location.pathname === '/login' || location.pathname === '/register'
    },
    {
      name: 'Catalogue',
      href: '/catalogue-materiels',
      icon: Package,
      active: location.pathname === '/catalogue-materiels' || location.pathname.startsWith('/catalogue-location-materiel-tournage-guadeloupe/')
    },
    {
      name: 'Panier',
      href: '/panier',
      icon: ShoppingCart,
      active: location.pathname === '/panier'
    },
    {
      name: 'Listes',
      href: isLoggedIn ? '/account/favorites' : '/login?redirect=/account/favorites',
      icon: List,
      active: location.pathname === '/account/favorites'
    },
    {
      name: 'Contact',
      href: '/contact',
      icon: Mail,
      active: location.pathname === '/contact'
    }
  ]

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-logo border-t border-logo z-50 md:hidden" style={{ position: 'fixed', bottom: 0, left: 0, right: 0, transform: 'translateZ(0)' }}>
      {/* Navigation */}
      <div className="flex justify-around items-center px-4 py-2">
        {navItems.map((item, index) => {
          const Icon = item.icon
          const isPanier = item.name === 'Panier'
          return (
            <motion.div
              key={item.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.3 }}
            >
              <Link
                to={item.href}
                className={`flex flex-col items-center py-2 px-3 rounded-lg transition-colors relative ${
                  item.active
                    ? 'text-white bg-logo hover:bg-logo'
                    : 'text-white hover:text-white hover:bg-logo'
                }`}
              >
                <motion.div 
                  className="relative"
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: 'spring', stiffness: 400, damping: 17 }}
                >
                  <Icon className="h-5 w-5 mb-1" />
                  {isPanier && totalCount > 0 && (
                    <motion.span 
                      className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-bold"
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      transition={{ type: 'spring', stiffness: 500, damping: 15 }}
                    >
                      {totalCount > 99 ? '99+' : totalCount}
                    </motion.span>
                  )}
                </motion.div>
                <span className="text-xs font-medium">{item.name}</span>
              </Link>
            </motion.div>
          )
        })}
      </div>
      
      {/* Copyright et version */}
      <div className="px-4 py-1 border-t border-orange-600/20">
        <p className="text-center text-xs text-white/80">
          Flightcase © {currentYear}{appVersion ? ` – v${appVersion}` : ''}
        </p>
      </div>
    </div>
  )
}

export default MobileBottomNav
